/**
 * ２重送信防止処理
 * ($httpProviderがもつ配列interceptorsに以下factoryを追加して
 *  サーバに引き渡される前のリクエストの前処理(２重送信防止処理)を定義する。）
 */
/* @ngInject */
export function interceptor(
    $q: ng.IQService,
    $injector: ng.auto.IInjectorService
): ng.IHttpInterceptor {
    return {
        request: (config: ng.IRequestConfig): (ng.IRequestConfig|ng.IPromise<ng.IRequestConfig>) => {
            let $http: ng.IHttpService = $injector.get<ng.IHttpService>('$http');

            function checkForDuplicates(config2: ng.IRequestConfig): boolean {
                return !!config2['unique'];
            }

            function checkIfDuplicated(config3: ng.IRequestConfig): boolean {
                let duplicated: ng.IRequestConfig[] = $http.pendingRequests.filter((pendingConfig: ng.IRequestConfig): boolean => {
                    return pendingConfig['screenId'] && pendingConfig['screenId'] === config3['screenId'];
                });
                return duplicated.length > 0;
            }

            function buildRejectedRequestPromise(config4: ng.IRequestConfig): ng.IPromise<ng.IRequestConfig> {
                let dfd: ng.IDeferred<ng.IRequestConfig> = $q.defer(),
                    reason: any = { data: {}, headers: {}, status: 499, config: config4 };
                dfd.reject(reason);
                return dfd.promise;
            }

            if (checkForDuplicates(config) && checkIfDuplicated(config)) {
                return buildRejectedRequestPromise(config);
            }
            return config || $q.when(config);
        }
    };
};



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/interceptor.ts
 **/